// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rs0_YYYkTH4WJoyJfyp6{border:1px solid var(--black-10);background:var(--background-primary-inverted-primary);border-radius:4px;width:-webkit-fit-content;width:fit-content;padding:4px;display:inline-flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `Rs0_YYYkTH4WJoyJfyp6`
};
export default ___CSS_LOADER_EXPORT___;
